import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntitateInruditaTypeComponent } from './entitate-inrudita-type.component';
import { AddEntitateInruditaTypeComponent } from './add-entitate-inrudita-type/add-entitate-inrudita-type.component';
import { EditEntitateInruditaTypeComponent } from './edit-entitate-inrudita-type/edit-entitate-inrudita-type.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        EntitateInruditaTypeComponent,
        AddEntitateInruditaTypeComponent,
        EditEntitateInruditaTypeComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [EntitateInruditaTypeComponent],
})
export class EntitateInruditaTypeModule { }
